import Vue from 'vue'
import Element from 'element-ui'
import '@/element-variables.scss'
import '@/compatible.scss'
import '@/elec-boot-style.scss'
import '@/elec-seal.scss'
import '@/elec-seal-inner.scss'


import '@/dropzone.scss'
import '@/elec-seal-inner-yun.scss'
import '@/loding.scss'
import '@/quill.snow.scss'
import '@/reset.scss'

Vue.use(Element)
